/* ==========================================================================
   MODULE CADEAU DU PANIER LATERAL - Atelier Sajada
   --------------------------------------------------------------------------
   Fichier : assets/ats-panier-cadeau.js

   A charger depuis layout/theme.liquid, avant </body> :
     <script src="{{ 'ats-panier-cadeau.js' | asset_url }}" defer></script>

   Ce code ne doit PAS vivre dans le snippet : quand le panier lateral se
   recharge, son contenu est injecte en innerHTML, et un <script> insere de
   cette facon n'est jamais execute par le navigateur. Les ecouteurs sont
   donc poses une seule fois sur document : ils survivent a tous les
   rechargements du panier.
   ========================================================================== */

(function () {
  if (window.atsCadeauPret) return;
  window.atsCadeauPret = true;

  var PLAFOND = 300;

  function racine(el) {
    return el.closest('[data-ats-cadeau]');
  }

  function argent(centimes) {
    return '\u20AC' + (centimes / 100).toFixed(2).replace('.', ',');
  }

  function tuiles(r) {
    return Array.prototype.slice.call(r.querySelectorAll('[data-ats-cadeau-tuile]'));
  }

  function selection(r) {
    return tuiles(r).filter(function (t) {
      return t.getAttribute('aria-pressed') === 'true';
    });
  }

  function erreur(r, texte) {
    var p = r.querySelector('[data-ats-cadeau-erreur]');
    if (!p) return;
    p.textContent = texte || '';
    p.classList.toggle('is-cache', !texte);
  }

  /* Le champ garde toujours une ligne vide d'avance sous le curseur, et ne
     descend jamais sous sa hauteur de depart. */
  function grandir(ta) {
    var styles = window.getComputedStyle(ta);
    var ligne = parseFloat(styles.lineHeight) || 21;
    var plancher = parseFloat(styles.minHeight) || 60;

    ta.style.height = 'auto';

    var souhaitee = ta.scrollHeight + ligne;
    var finale = Math.max(plancher, Math.min(souhaitee, PLAFOND));

    ta.style.height = finale + 'px';
    ta.style.overflowY = souhaitee > PLAFOND ? 'auto' : 'hidden';
  }

  function majCompteur(r, ta) {
    var cpt = r.querySelector('[data-ats-cadeau-compteur]');
    if (!cpt) return;
    var n = ta.value.length;
    var max = parseInt(r.dataset.max, 10) || 500;
    var seuil = parseInt(r.dataset.seuil, 10) || Math.round(max * 0.8);
    cpt.textContent = n + ' / ' + max;
    cpt.classList.toggle('is-visible', n >= seuil);
  }

  function majTotal(r) {
    var sel = selection(r);
    var total = 0;
    var carteSel = false;

    sel.forEach(function (t) {
      total += parseInt(t.dataset.prix, 10) || 0;
      if (t.dataset.role === 'carte') carteSel = true;
    });

    var btn = r.querySelector('[data-ats-cadeau-ajouter]');
    if (btn) {
      btn.textContent = sel.length === 0
        ? r.dataset.libelleVide
        : r.dataset.libelleAjout + ' \u2014 ' + argent(total);
    }

    var zone = r.querySelector('[data-ats-cadeau-message]');
    if (zone) {
      zone.classList.toggle('is-cache', !carteSel);
      if (carteSel) {
        var champ = zone.querySelector('[data-ats-cadeau-champ]');
        if (champ) grandir(champ);
      }
    }
  }

  /* ---------- redessin du panier ----------
     On ne remplace jamais la section entiere : le tiroir est un <dialog>
     pilote par <theme-drawer>, le detruire le referme. On echange
     seulement l'interieur des zones de contenu, et on ne previent le
     theme que tiroir ferme. */

  var ZONES = [
    '.cart-items__wrapper',
    '.cart__summary-totals',
    '#cart-progress-bar'
  ];

  function tiroirOuvert() {
    var dlg = document.querySelector('#cart-drawer, cart-drawer-component');
    if (!dlg) return false;
    if (dlg.tagName === 'DIALOG' && dlg.open) return true;
    if (dlg.hasAttribute && dlg.hasAttribute('open')) return true;
    var parent = dlg.closest ? dlg.closest('dialog, theme-drawer') : null;
    return !!(parent && (parent.open || parent.hasAttribute('open')));
  }

  function sectionsDuPanier() {
    var trouvees = [];
    var hotes = document.querySelectorAll(
      'cart-drawer-component, cart-items-component, #cart-drawer'
    );
    for (var i = 0; i < hotes.length; i++) {
      var section = hotes[i].closest('[id^="shopify-section-"]');
      if (!section) continue;
      var nom = section.id.replace('shopify-section-', '');
      var deja = false;
      for (var j = 0; j < trouvees.length; j++) {
        if (trouvees[j].nom === nom) deja = true;
      }
      if (!deja) trouvees.push({ nom: nom, id: section.id });
    }
    return trouvees;
  }

  function rafraichir() {
    var sections = sectionsDuPanier();
    if (!sections.length) {
      window.location.reload();
      return;
    }

    var noms = sections.map(function (s) { return s.nom; });

    fetch('/?sections=' + encodeURIComponent(noms.join(',')), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (rendus) {
        sections.forEach(function (s) {
          var html = rendus[s.nom];
          var hote = document.getElementById(s.id);
          if (!html || !hote) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');

          ZONES.forEach(function (selecteur) {
            var vivantes = hote.querySelectorAll(selecteur);
            var fraiches = doc.querySelectorAll(selecteur);
            var n = Math.min(vivantes.length, fraiches.length);
            for (var i = 0; i < n; i++) {
              if (vivantes[i].innerHTML !== fraiches[i].innerHTML) {
                vivantes[i].innerHTML = fraiches[i].innerHTML;
              }
            }
          });
        });

        if (!tiroirOuvert()) {
          ['cart:update', 'cart:refresh'].forEach(function (nom) {
            document.dispatchEvent(new CustomEvent(nom, {
              bubbles: true,
              detail: { source: 'ats-cadeau' }
            }));
          });
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function ajouter(r) {
    var btn = r.querySelector('[data-ats-cadeau-ajouter]');
    var sel = selection(r);
    if (!sel.length || !btn) return;

    var ta = r.querySelector('[data-ats-cadeau-champ]');
    var manuscrit = r.querySelector('[data-ats-cadeau-manuscrit]');
    var carteSel = sel.some(function (t) {
      return t.dataset.role === 'carte';
    });

    var message = '';
    if (carteSel) {
      if (manuscrit && manuscrit.checked) {
        message = r.dataset.texteManuscrit;
      } else {
        message = ta ? ta.value.trim() : '';
        if (!message) {
          erreur(r, r.dataset.texteMessageVide);
          if (ta) ta.focus();
          return;
        }
      }
    }

    erreur(r, '');

    var items = sel.map(function (t) {
      var ligne = { id: parseInt(t.dataset.variant, 10), quantity: 1 };
      if (t.dataset.role === 'carte' && message) {
        ligne.properties = {};
        ligne.properties[r.dataset.nomPropriete] = message;
      }
      return ligne;
    });

    btn.disabled = true;
    btn.textContent = r.dataset.libelleEnvoi;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('ajout');
        return res.json();
      })
      .then(function () {
        rafraichir();
      })
      .catch(function () {
        btn.disabled = false;
        majTotal(r);
        erreur(r, r.dataset.texteErreur);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('[data-ats-cadeau-toggle]');
    if (toggle) {
      var r1 = racine(toggle);
      if (!r1) return;
      var panneau = r1.querySelector('.ats-cadeau__panneau');
      var ouvert = r1.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (panneau) panneau.classList.toggle('is-cache', !ouvert);
      if (ouvert) {
        majTotal(r1);
        setTimeout(function () {
          r1.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 60);
      }
      return;
    }

    var tuile = e.target.closest('[data-ats-cadeau-tuile]');
    if (tuile && !tuile.disabled) {
      var r2 = racine(tuile);
      if (!r2) return;
      var actif = tuile.getAttribute('aria-pressed') === 'true';
      tuile.setAttribute('aria-pressed', actif ? 'false' : 'true');
      tuile.classList.toggle('is-on', !actif);
      erreur(r2, '');
      majTotal(r2);
      return;
    }

    var ajout = e.target.closest('[data-ats-cadeau-ajouter]');
    if (ajout) {
      var r3 = racine(ajout);
      if (r3) ajouter(r3);
    }
  });

  /* Les tuiles sont precochees en Liquid : on aligne le bouton et la zone
     de message des l'ouverture du tiroir, puis a chaque redessin du
     panier (le module est reconstruit avec lui). */
  function initialiser() {
    var modules = document.querySelectorAll('[data-ats-cadeau]');
    for (var i = 0; i < modules.length; i++) {
      majTotal(modules[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiser);
  } else {
    initialiser();
  }

  ['cart:update', 'cart:refresh'].forEach(function (nom) {
    document.addEventListener(nom, function () { setTimeout(initialiser, 150); });
  });

  if (window.MutationObserver) {
    var cible = document.querySelector('cart-drawer-component, #cart-drawer, main');
    if (cible) {
      var minuteur = null;
      new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(initialiser, 200);
      }).observe(cible, { childList: true, subtree: true });
    }
  }

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest) return;
    var ta = e.target.closest('[data-ats-cadeau-champ]');
    if (!ta) return;
    var r = racine(ta);
    if (!r) return;

    var avant = ta.style.height;
    grandir(ta);
    majCompteur(r, ta);
    erreur(r, '');

    if (avant !== ta.style.height) {
      ta.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var champ = e.target.closest('[data-ats-cadeau-manuscrit]');
    if (!champ) return;
    var r = racine(champ);
    if (!r) return;
    var ta = r.querySelector('[data-ats-cadeau-champ]');
    if (!ta) return;

    ta.disabled = e.target.checked;
    if (e.target.checked) {
      ta.value = '';
      majCompteur(r, ta);
    }
    grandir(ta);
    erreur(r, '');
  });
})();